import { DataTableImageColumn } from "~components/DataTable/components/DataTableImageColumn/DataTableImageColumn.tsx";
import { ImageTypes } from "~enums/imageTypes";
import type { Entity } from "~types/entity";

type Props = {
  entity: Pick<Entity, "images" | "nameFullLocal">;
};

const EntityColumn = ({ entity }: Props) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
      {entity && <DataTableImageColumn images={entity?.images} imageTypes={[ImageTypes.Logo, ImageTypes.LogoAlternate]} />}
      <span>{entity?.nameFullLocal}</span>
    </div>
  );
};
export default EntityColumn;
